import type { ServiceStatusData } from '@ps/web-shared-api-types/v1-preview/SwHomeGames';

export const isSingleRecordUpdate = (response: ServiceStatusData[]) => response.length === 1;

export const handleSingleRecordUpdate = (
  serviceStatusData: ServiceStatusData[],
  recordToUpdate: ServiceStatusData
) => {
  const updatedServiceStatusData = [...serviceStatusData];
  const existingRecordIndex = serviceStatusData.findIndex(
    (item) => item.serverObject === recordToUpdate.serverObject
  );

  if (existingRecordIndex !== -1) {
    updatedServiceStatusData[existingRecordIndex] = recordToUpdate;
  } else {
    updatedServiceStatusData.push(recordToUpdate);
  }
  return updatedServiceStatusData;
};
